import { render, staticRenderFns } from "./MomoProfile.vue?vue&type=template&id=5cce19ec&"
import script from "./MomoProfile.vue?vue&type=script&lang=js&"
export * from "./MomoProfile.vue?vue&type=script&lang=js&"
import style0 from "./MomoProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports